import { render, staticRenderFns } from "./matter_edit.vue?vue&type=template&id=416b53a6&scoped=true&"
import script from "./matter_edit.vue?vue&type=script&lang=js&"
export * from "./matter_edit.vue?vue&type=script&lang=js&"
import style0 from "./matter_edit.vue?vue&type=style&index=0&id=416b53a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416b53a6",
  null
  
)

export default component.exports